// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__28FkQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3HbED","obliqueLine":"membershipbadge_obliqueLine__3r28B"};